import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Container,
  Typography,
  Box,
  Paper,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  CircularProgress,
  Alert,
} from '@mui/material';
import {
  ArrowBack as BackIcon,
  Topic as TopicIcon,
} from '@mui/icons-material';

const API_URL = process.env.REACT_APP_API_URL;

const areaNames = {
  matematicas: 'Matemáticas',
  'lectura-critica': 'Lectura Crítica',
  sociales: 'Sociales y Ciudadanas',
  ciencias: 'Ciencias Naturales',
  ingles: 'Inglés',
};

const topicNames = {
  algebra: 'Álgebra',
  geometria: 'Geometría',
  estadistica: 'Estadística',
  'comprension-lectora': 'Comprensión Lectora',
  'tipos-de-texto': 'Tipos de Texto',
  'literatura-latinoamericana': 'Literatura Latinoamericana',
  'historia-colombia': 'Historia de Colombia',
  'geografia-colombia': 'Geografía de Colombia',
  'constitucion-politica': 'Constitución Política',
  biologia: 'Biología',
  quimica: 'Química',
  fisica: 'Física',
  'reading-comprehension': 'Reading Comprehension',
  grammar: 'Grammar',
  vocabulary: 'Vocabulary',
};

const StudyTopics = () => {
  const { area } = useParams();
  const navigate = useNavigate();
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchTopics();
  }, [area]);

  const fetchTopics = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/study/topics/${area}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTopics(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching topics:', err);
      setError('Error al cargar los temas');
      setLoading(false);
    }
  };

  const handleTopicClick = (topic) => {
    navigate(`/study/${area}/content?topic=${topic}`);
  };

  const handleBack = () => {
    navigate(`/area/${area}`);
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Button
        startIcon={<BackIcon />}
        onClick={handleBack}
        sx={{ mb: 3 }}
      >
        Volver
      </Button>

      <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          📚 Estudiar {areaNames[area]}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Selecciona un tema para estudiar su contenido
        </Typography>
      </Paper>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      {topics.length === 0 ? (
        <Alert severity="info">
          No hay temas disponibles para esta área aún.
        </Alert>
      ) : (
        <Paper elevation={2}>
          <List>
            {topics.map((topic, index) => (
              <ListItem key={index} disablePadding>
                <ListItemButton
                  onClick={() => handleTopicClick(topic)}
                  sx={{
                    py: 2,
                    '&:hover': {
                      bgcolor: 'primary.light',
                      color: 'white',
                    },
                  }}
                >
                  <ListItemIcon>
                    <TopicIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary={topicNames[topic] || topic}
                    secondary={`Contenidos de ${topicNames[topic] || topic}`}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
    </Container>
  );
};

export default StudyTopics;
